module.exports = __webpack_public_path__ + "static/scale-model-of-public-art-\"ocean\"-in-torrance-california-9ce613c6e3aacaf7e6616739b2906c77.png";